import { mapState, mapMutations } from 'vuex'
import Validator from '@/utils/Validator'

export default {
  name: 'PasswordInput',
  data () {
    return {
      // 入力値
      inpCurrentPassword: '',
      inpPassword: '',
      inpPasswordConfirm: '',
      isClickedConfirm: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      values: state => state.password.values
    }),
    // validate
    inpCurrentPasswordIsValid () {
      if (!this.isClickedConfirm) return true
      return Validator.validText(this.inpCurrentPassword)
    },
    inpPasswordIsValid () {
      if (!this.isClickedConfirm) return true
      return Validator.validText(this.inpPassword)
    },
    inpPasswordConfirmIsValid () {
      if (!this.isClickedConfirm) return true
      return this.inpPassword === this.inpPasswordConfirm
    },
    formIsValid () {
      // return true
      return this.inpCurrentPasswordIsValid &&
         this.inpPasswordIsValid &&
        this.inpPasswordConfirmIsValid
    },
    disableConfirmButton () {
      return !Validator.validText(this.inpCurrentPassword) ||
        !Validator.validText(this.inpPassword) ||
        this.inpPassword !== this.inpPasswordConfirm
    }
  },
  methods: {
    ...mapMutations({
      setValues: 'password/setValues'
    }),
    init () {
      // 確認画面から戻った時、編集に宣した時に値を挿入
      // if (this.values) this.isClickedConfirm = true
      if (this.values.currentPassword) this.inpCurrentPassword = this.values.currentPassword
      if (this.values.password) this.inpPassword = this.values.password
      if (this.values.password) this.inpPasswordConfirm = this.values.password
    },
    confirmData () {
      this.isClickedConfirm = true
      // console.log(this.invalidFlag)

      // validate
      if (this.formIsValid) {
        let data = {
          currentPassword: this.inpCurrentPassword,
          password: this.inpPassword
        }
        this.setValues(data)
        this.$router.push({
          name: 'PasswordConfirm'
        })
      }
    }
  }
}
